import {AfterViewInit, Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[sbAutofocus]',
  standalone: false,
})
export class SbAutofocusDirective implements AfterViewInit {
  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.elementRef.nativeElement.focus();
    }, 0);
  }
}
